import React, { useContext, useEffect, useState } from "react";

import { api, unauthorizedHandler } from "services";
import { getToken, removeToken, setToken } from "helpers";

interface Props {
  children: React.ReactNode;
}

const GlobalContext = React.createContext({
  isLoggedIn: true,
  loginUser: (token: string) => {},
  logoutUser: () => {},
});

export const GlobalProvider = ({ children }: Props) => {
  const [isLoggedIn, setIsLoggedIn] = useState(!!getToken());

  const loginUser = (token: string) => {
    setIsLoggedIn(true);
    setToken(token);
  };

  const logoutUser = () => {
    setIsLoggedIn(false);
    removeToken();
  };

  // Handle when server returns 401
  useEffect(() => {
    const authInterceptor = api.interceptors.request.use(
      (resp) => resp,
      unauthorizedHandler(logoutUser)
    );
    return () => {
      api.interceptors.request.eject(authInterceptor);
    };
  }, []);

  return (
    <GlobalContext.Provider
      value={{
        isLoggedIn,
        loginUser,
        logoutUser,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalProvider = () => {
  return useContext(GlobalContext);
};

export const useAuth = () => {
  const { isLoggedIn, loginUser, logoutUser } = useGlobalProvider();
  return { isLoggedIn, loginUser, logoutUser };
};
